<template>
    <el-dialog
    title="温度设置"
    :visible.sync="visible"
    @opened="openDialog"
    class="tempSetDialog"
    @close="closeDialog"
    :modal-append-to-body="false"
    :close-on-click-modal="true"
    :append-to-body="true"
    :class="visible ? 'flip-in-hor-bottom' : ''"
  >
      <div class="add-sensor-body">
        <!-- <span class="pane-title">添加传感器</span> -->
        <el-form
          label-position="left"
          label-width="7rem"
          inline
          :rules="rules"
          :model="form1"
          style="margin-left: 30px; margin-top: 30px; margin-right: 30px"
          ref="ruleForm"
        >
          <el-form-item label="预警温度值：" prop="earlyWarningTemper">
            <el-input v-model="form1.earlyWarningTemper"></el-input>
          </el-form-item>
          <el-form-item label="告警温度值：" prop="warningReference">
            <el-input v-model="form1.warningReference"></el-input>
          </el-form-item>
        </el-form>

        <div style="text-align: center">
          <button class="btn3" @click="updateTemperWarning()">确定</button>
          <button class="btn4" @click="closeDialog">取消</button>
        </div>
      </div>
  </el-dialog>
 
</template>

<script>
import commonUtils from "@/utils/common";
import datePicker from "@/components/datePicker.vue";
import Pagination from "@/components/Pagination.vue";
import { log } from "three";
export default {
  components: { datePicker, Pagination },
  data() {
    return {
      total: 100,
      pageNo: 1,
      pageSize: 10,
      warningReference: "",
      earlyWarningTemper: "",
      id: "",
      visible: false,
      rules: {
        earlyWarningTemper: [
          { required: true, message: "预警温度值不能为空", trigger: "blur" },
        ],
        warningReference: [
          { required: true, message: "告警温度值不能为空", trigger: "blur" },
        ],
      },
      form1: {
        warningReference: "",
        earlyWarningTemper: "",
      },
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    updateTemperWarning() {
      const params = {
        earlyWarningTemper: this.form1.earlyWarningTemper,
        id: this.id,
        warningTemper: this.form1.warningReference,
      };
      this.$api.sensor
        .updateTemperWarning(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("更新成功!");
            this.visible = false;
            this.$store.state.refreshHistoryData =
              !this.$store.state.refreshHistoryData;
              this.$emit("getOneSensorHistory");
          } else {
            this.$message.error(res.msg);
            this.$emit("getOneSensorHistory");
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    openDialog() {},
    closeDialog() {
      this.visible = false;
    },
    //选择时间
    confirmDate(min, max) {
      if (min) {
        //选择时间
        this.maxTime = max;
        this.minTime = min;
      } else {
        //清空时间，取默认
        this.dateValue = [
          new Date(new Date().getTime() - 3600 * 24 * 1000),
          new Date(),
        ];

        this.maxTime = commonUtils.timeFormat(new Date());
        this.minTime = commonUtils.timeFormat(
          new Date(new Date().getTime() - 3600 * 24 * 1000)
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tempSetDialog {
  /deep/ .el-dialog__title {
    font-size: 1.5rem;
  }
  /deep/ .el-input__inner {
    border-radius: 0px;
    border: 1px solid #c0e9ff1f;
    background: var(--input-bg);
    color: var(--titleName-color);
    border-radius: 0px;
  }
  /deep/ .el-form-item__label {
    font-size: 0.875rem;
  }

  //   /deep/ .el-select {
  //     width: 215px;
  //   }
  //   /deep/ .el-select-dropdown__wrap.el-scrollbar__wrap {
  //     overflow: auto;
  //     background-color: #244447;
  //     border: none;
  //   }
  //   /deep/ .el-select-dropdown {
  //     border: none;
  //   }
  //   /deep/ .el-select-dropdown__item.hover,
  //   .el-select-dropdown__item:hover {
  //     color: #d3fbff;
  //     background-color: #3f98a0;
  //   }

  //   /deep/ .el-select-dropdown__item.selected {
  //     color: #d3fbff;
  //   }
  //   /deep/ .el-select-dropdown__item {
  //     color: rgba(255, 255, 255, 0.603);
  //   }

  //   /deep/.el-dialog__body {
  //     // padding: 25px 20px !important;
  //     color: #ffffff;
  //     background: #182732;
  //   }

  //   /deep/ .el-dialog {
  //     background: #344142ec;
  //     width: 55rem;
  //     // height: 43.75rem;
  //   }

  //   /deep/ .pagination-container {
  //     text-align: center;
  //   }
  //   /deep/ .el-textarea__inner {
  //     width: 31.25rem;
  //     height: 8rem;
  //     color: white;
  //     border-radius: 0.25rem;
  //     border: 0.1875rem solid #c0e9ff1f;
  //     background: #24444757;
  //     border-radius: 0px;
  //     font-size: 0.875rem;
  //   }
  //   /deep/ .el-textarea__inner:focus {
  //     border-color: #55b1b1 !important;
  //   }
}

//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219e82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219e82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn3:hover {
  background: #44d7b6;
}
.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44d7b6;
  background: transparent;
  color: #44d7b6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn4:hover {
  background: #44d7b655;
}
.pane-title {
  padding-left: 30px;
  font-size: 21px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5bb3bc;
  line-height: 32px;
}

.add-sensor-body {
  .el-divider__text {
    background-color: rgb(17, 32, 38) !important;
    color: #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/temp-set.vue